"use client";
import { Audio } from "../../media/audio.js";
import { MinimalLiveAudioSkin } from "./minimal-skin.js";
import { LiveAudioPlayer, usePlayer } from "./player.js";
import { LiveAudioSkin } from "./skin.js";
import { liveAudioFeatures } from "@videojs/core/dom";
//#region src/presets/live-audio/index.ts
/**
* Live audio player preset — `audio` minus playback rate, plus the live feature, with a skin that swaps the time slider
* and time displays for a Live button.
*/
//#endregion
export { Audio, LiveAudioPlayer, LiveAudioSkin, MinimalLiveAudioSkin, liveAudioFeatures, usePlayer };

//# sourceMappingURL=index.js.map